export default [
  {
    path: '/pledge-2021/index',
    name: 'index',
    component: () => import('@/views/pledge-2021'),
    meta: {
      title: '2021高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2021/pledgeall',
    name: 'pledgeall',
    component: () => import('@/views/pledge-2021/pledgeall'),
    meta: {
      title: '2021高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2021/pledgeform',
    name: 'pledgeform',
    component: () => import('@/views/pledge-2021/pledgeform'),
    meta: {
      title: '2021高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2021/pledgepersonal',
    name: 'pledgepersonal',
    component: () => import('@/views/pledge-2021/pledgepersonal'),
    meta: {
      title: '2021高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2021/pledgeshare/:id',
    name: 'pledgeshare',
    component: () => import('@/views/pledge-2021/pledgeshare'),
    meta: {
      title: '2021高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2021/pledgevoice',
    name: 'pledgevoice',
    component: () => import('@/views/pledge-2021/pledgevoice'),
    meta: {
      title: '2021高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2021/pledgelist/:province_id',
    name: 'pledgelist',
    component: () => import('@/views/pledge-2021/pledgelist'),
    meta: {
      title: '2021高考誓师大会-高考直通车'
    }
  },
  {
    path: '/pledge-2021/pledgecard/:id',
    name: 'pledgecard',
    component: () => import('@/views/pledge-2021/pledgecard'),
    meta: {
      title: '2021高考誓师大会-高考直通车'
    }
  }
]
